import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const sizeClasses = {
    sm: css({
        fontSize: "14px",
        lineHeight: "20px",
    }),
    base: css({
        fontSize: "16px",
        lineHeight: "25px",
    }),
    md: css({
        fontSize: "18px",
        lineHeight: "25px",
    }),
    lg: css({
        fontSize: "21px",
        lineHeight: "30px",
    }),
    xl: css({
        fontSize: "24px",
        lineHeight: "35px",
    }),
    xxl: css({
        fontSize: "27px",
        lineHeight: "35px",
    }),
};
const fontWeightClasses = {
    light: css({
        fontWeight: 300,
    }),
    bold: css({
        fontWeight: "bold",
    }),
    regular: undefined,
};
const reTextClass = css({
    "&:not(:last-child)": {
        marginBottom: 0,
    },
});
export class Text extends React.Component {
    render() {
        const classes = [reTextClass];
        this.props.color &&
            classes.push(css({
                color: getThemeColorVar(this.props.color, this.props.colorType),
            }));
        const weightClass = this.props.fontWeight && fontWeightClasses[this.props.fontWeight];
        weightClass && classes.push(weightClass);
        this.props.italic &&
            classes.push(css({
                fontStyle: "italic",
            }));
        classes.push(sizeClasses[this.props.size || "base"]);
        return this.props.inline ? (React.createElement("span", { style: this.props.additionalStyles, className: cx(classes) }, this.props.children)) : (React.createElement("p", { style: this.props.additionalStyles, className: cx(classes) }, this.props.children));
    }
}
export const ReText = Text;
export default Text;
//# sourceMappingURL=text.js.map